const environment = () => {
var location = window.location.href,
    env = { //This will be served for localhost
		orderAPIUrl: 'https://cnet.api.geappliances.io/orders-qa/',
		nodeAPIurl: 'https://cnet.api.geappliances.io/node-qa/',
		reportsAPIUrl: 'https://cnet.api.geappliances.io/reports-qa/',
		productAPIUrl: 'https://cnet.api.geappliances.io/products-qa/',
		s3BucketAPIBaseURL: 'https://cnet.api.geappliances.io/node-qa/requestUploadURL',
		s3StaticDataURL: 'https://s3.amazonaws.com/ee-app-fileuploads-qa/CustomerNet',
		userAPIUrl: 'https://cnet.api.geappliances.io/users-qa/',
		servicesAPIUrl: 'https://cnet.api.geappliances.io/services-qa/',
		customerAPIUrl: 'https://cnet.api.geappliances.io/customers-qa/',
		cyberSourceRedirectURL: 'https://cnet.api.geappliances.io/node-qa/response',
		searchAndPayInvoicesURLEmp: 'https://globalerp-stg.appl.ge.com/',
		searchAndPayInvoicesURLCust: 'https://globalerp-stg.appl.ge.com/',
		loginAPIUrl: "https://cnet.api.geappliances.io/python-prd/",
		loginAPIKey: "rCG8agwU113D6hyzBlAAHactc88eCSr87GcDwNlk",
		westLoginAPIKey: "rCG8agwU113D6hyzBlAAHactc88eCSr87GcDwNlk",
		bootAPIUrl: "https://customernetapi-qa.geappliances.com/api/cnet/",
		pNetAPIUrl: "https://partsnetapi-qa.geappliances.com/api/pnet/",
		cyberSourceURL: 'https://testsecureacceptance.cybersource.com/token/create',
		s3BrochureUrl: 'https://s3.amazonaws.com/ee-app-fileuploads-qa/CustomerNet/tmp/',
		profileId: "EC265CDE-05C0-42CB-9A14-8E9607E01A00",
		accessKey: "d73733766bf439c083dc27448b67ce97",
		hvac : {"name":"HVAC", "subCategory" : [ {"name":"Ducted HVAC", "categoryId":"3672"}, {"name":"Ductless HVAC", "categoryId":"3673"}]},
		ncrpData: {
			accountNumber: '116153688',
			legacyOrderAccountNumber: '89874214',
			invoiceToAddress: {
				ADDRESS1: "400 Buechel Bank Rd",
				CITY: "Louisville",
				POSTALCODE: "40225-0000",
				STATE: "KY",
				COUNTRY: "US",
			}
		},
		ssoUrl : "https://ssononprod.geappliances.com/samlp/PO211eFqansHfIkkuXJFae477dupTWt6",
		ssoGEUrl : "https://geappliances.okta.com/app/geappliances_customernetdev_1/exkohwu23tq0YMkpN697/sso/saml",
		logoutSSOUrl : "https://ssononprod.geappliances.com/v2/logout?client_id=PO211eFqansHfIkkuXJFae477dupTWt6&returnTo=https://customernet-qa.geappliances.com",
        typeOfEmployeeAccessLevel: [
            {
                typeOfEmployee: 'asm',
                accessLevel: [
                    'Price',			// Done
                    'Price Discounts', 	// Done
                    'View Orders',
                    'Create New Order',	// Done
                    'Edit Orders',		// Done
        			'Returns/Credits',	// Done
        			'Invoices and Payments',
        			'Manage Users',		// Done
        			'User Requests',	// Done
        			'Approve Returns',	// Done
                    'View Reports',     // Done
                ]
            }, 
			{
				typeOfEmployee: 'om',
				accessLevel: [
					'Price',			// Done
					'Price Discounts', 	// Done
					'View Orders',
					'Create New Order',	// Done
					'Edit Orders',		// Done
					'Returns/Credits',	// Done
					'Invoices and Payments',
					'View Reports',     // Done
				]
			},
			{
                typeOfEmployee: 'dl',
                accessLevel: [
                    'Price',			// Done
                    'Price Discounts', 	// Done
                    'View Orders',
                    'Create New Order',	// Done
                    'Edit Orders',		// Done
        			'Returns/Credits',	// Done
        			'Invoices and Payments',
        			'Manage Users',		// Done
        			'User Requests',	// Done
        			'Site Management',	// Done
        			'Approve Returns',	// Done
        			'Update User',
                    'View Reports',     // Done
                ]
            }, {
                typeOfEmployee: 'otherasm',
                accessLevel: [
                    'Price',
                    'Price Discounts',
                    'View Orders',
                    'Create New Order',
                    'Edit Orders',
        			'Returns/Credits',	// Done
        			'Invoices and Payments',
                    'View Reports',     // Done
                ]
            }, {
                typeOfEmployee: 'normal',
                accessLevel: [
                    'View Orders',
                    // IMPORTANT NOTE START: Below access are ONLy for local application for testing
        			'Approve Returns',
        			'Price',
                    'Price Discounts',
                    'View Orders',
                    'Create New Order',
                    'Edit Orders',
        			'Returns/Credits',
        			'Invoices and Payments',
        			'Manage Users',		// Done
        			'User Requests',
                    'Site Management',	// Done
        			'Update User',
                    'View Reports',     // Done
                    // IMPORTANT NOTE END: Till here
                ]
            }
        ]
	};
	if(location.indexOf('geappliancescustomernet.com') !== -1) {
	    env = {
			orderAPIUrl: 'https://cnet.api.geappliances.io/orders-prd/',
			nodeAPIurl: 'https://cnet.api.geappliances.io/node-prd/',
			reportsAPIUrl: 'https://cnet.api.geappliances.io/reports-prd/',
			productAPIUrl: 'https://cnet.api.geappliances.io/products-prd/',
			s3BucketAPIBaseURL: 'https://cnet.api.geappliances.io/node-prd/requestUploadURL',
			s3StaticDataURL: 'https://s3.amazonaws.com/ee-app-fileuploads-prd/CustomerNet',
            userAPIUrl: 'https://cnet.api.geappliances.io/users-prd/',
            servicesAPIUrl: 'https://cnet.api.geappliances.io/services-prd/',
			customerAPIUrl: 'https://cnet.api.geappliances.io/customers-prd/',
			cyberSourceRedirectURL: 'https://cnet.api.geappliances.io/node-prd/response',
			searchAndPayInvoicesURLEmp: 'https://globalerp.appl.ge.com',
            searchAndPayInvoicesURLCust: 'https://secure.p.geappliances.com/OA_HTML/AppsLogin',
			loginAPIUrl: "https://cnet.api.geappliances.io/python-prd/",
			loginAPIKey:"rCG8agwU113D6hyzBlAAHactc88eCSr87GcDwNlk",
			westLoginAPIKey: "K7JYUNciZm3Y3npnVNjST6mpKx2WTwQL1MIFs0vw",
			bootAPIUrl: "https://customernetapi.geappliances.com/api/cnet/",
			pNetAPIUrl: "https://partsnetapi.geappliances.com/api/pnet/",
			cyberSourceURL: 'https://secureacceptance.cybersource.com/embedded/token/create',
			s3BrochureUrl: 'https://s3.amazonaws.com/ee-app-fileuploads-prd/CustomerNet/tmp/',
			profileId: "7B12FFE0-F47F-4872-A7C2-96A5ABCA5E25",
			accessKey: "432dc525628a391da7df9564fda21f79",
			hvac : {"name":"HVAC", "subCategory" : [ {"name":"Ducted HVAC", "categoryId":"3690"}, {"name":"Ductless HVAC", "categoryId":"3689"}]},
			ncrpData: {
				accountNumber: '116153688',
				legacyOrderAccountNumber: '89874214',
				invoiceToAddress: {
					ADDRESS1: "400 Buechel Bank Rd",
            		CITY: "Louisville",
                	POSTALCODE: "40225-0000",
                	STATE: "KY",
                	COUNTRY: "US",
				}
			},
			ssoUrl : "https://sso.geappliances.com/samlp/7E3yh8VpKLKvZC15GomB5HyxXHYbMm0S",
			ssoGEUrl : "https://geappliances.okta.com/app/geappliances_customernet_1/exksb2gzpsDzXBdyA697/sso/saml",
			logoutSSOUrl : "https://sso.geappliances.com/v2/logout?client_id=7E3yh8VpKLKvZC15GomB5HyxXHYbMm0S&returnTo=https://geappliancescustomernet.com",
            typeOfEmployeeAccessLevel: [
                {
                    typeOfEmployee: 'asm',
                    accessLevel: [
                        'Price',			/// Done
                        'Price Discounts', 	// Done
                        'View Orders',
                        'Create New Order',	// Done
                        'Edit Orders',		// Done
            			'Returns/Credits',	// Done
            			'Invoices and Payments',
            			'Manage Users',		// Done
            			'User Requests',	// Done
            			'Approve Returns',	// Done
                        'View Reports',     // Done
                    ]
                }, 
				{
                    typeOfEmployee: 'om',
                    accessLevel: [
                        'Price',			// Done
                        'Price Discounts', 	// Done
                        'View Orders',
                        'Create New Order',	// Done
                        'Edit Orders',		// Done
            			'Returns/Credits',	// Done
            			'Invoices and Payments',
                        'View Reports',     // Done
                    ]
                },
				{
                    typeOfEmployee: 'dl',
                    accessLevel: [
                        'Price',			// Done
                        'Price Discounts', 	// Done
                        'View Orders',
                        'Create New Order',	// Done
                        'Edit Orders',		// Done
            			'Returns/Credits',	// Done
            			'Invoices and Payments',
            			'Manage Users',		// Done
            			'User Requests',	// Done
            			'Site Management',	// Done
            			'Approve Returns',	// Done
            			'Update User',
                        'View Reports',     // Done
                    ]
                }, {
                    typeOfEmployee: 'otherasm',
                    accessLevel: [
                        'Price',
                        'Price Discounts',
                        'View Orders',
                        'Create New Order',
                        'Edit Orders',
            			'Returns/Credits',	// Done
            			'Invoices and Payments',
                        'View Reports',     // Done
                    ]
                }, {
                    typeOfEmployee: 'normal',
                    accessLevel: [
                        'View Orders',
                    ]
                }
            ]
	    };// Adding WEST ZONE APIs redirect 
	} else if(location.indexOf('west.geappliancescustomernet.com') !== -1){
		env = {
			orderAPIUrl: 'https://cnet-west.api.geappliances.io/orders-prd/',
			nodeAPIurl: 'https://cnet-west.api.geappliances.io/node-prd/',
			reportsAPIUrl: 'https://cnet-west.api.geappliances.io/reports-prd/',
			productAPIUrl: 'https://cnet-west.api.geappliances.io/products-prd/',
			s3BucketAPIBaseURL: 'https://cnet-west.api.geappliances.io/node-prd/requestUploadURL',
			s3StaticDataURL: 'https://s3.amazonaws.com/ee-app-fileuploads-prd/CustomerNet',
            userAPIUrl: 'https://cnet-west.api.geappliances.io/users-prd/',
            servicesAPIUrl: 'https://cnet-west.api.geappliances.io/services-prd/',
			customerAPIUrl: 'https://cnet-west.api.geappliances.io/customers-prd/',
			cyberSourceRedirectURL: 'https://cnet-west.api.geappliances.io/node-prd/response',
			searchAndPayInvoicesURLEmp: 'https://globalerp.appl.ge.com',
            searchAndPayInvoicesURLCust: 'https://secure.p.geappliances.com/OA_HTML/AppsLogin',
			loginAPIUrl: "https://cnet-west.api.geappliances.io/python-prd/",
			loginAPIKey: "K7JYUNciZm3Y3npnVNjST6mpKx2WTwQL1MIFs0vw",
			westLoginAPIKey: "K7JYUNciZm3Y3npnVNjST6mpKx2WTwQL1MIFs0vw",
			bootAPIUrl: "https://customernetapi.geappliances.com/api/cnet/",
			pNetAPIUrl: "https://partsnetapi.geappliances.com/api/pnet/",
			cyberSourceURL: 'https://secureacceptance.cybersource.com/embedded/token/create',
			s3BrochureUrl: 'https://s3.amazonaws.com/ee-app-fileuploads-prd/CustomerNet/tmp/',
			profileId: "7B12FFE0-F47F-4872-A7C2-96A5ABCA5E25",
			accessKey: "432dc525628a391da7df9564fda21f79",
			hvac : {"name":"HVAC", "subCategory" : [ {"name":"Ducted HVAC", "categoryId":"3690"}, {"name":"Ductless HVAC", "categoryId":"3689"}]},
			ncrpData: {
				accountNumber: '116153688',
				legacyOrderAccountNumber: '89874214',
				invoiceToAddress: {
					ADDRESS1: "400 Buechel Bank Rd",
					CITY: "Louisville",
					POSTALCODE: "40225-0000",
					STATE: "KY",
					COUNTRY: "US",
				}
			},
			ssoUrl : "https://sso.geappliances.com/samlp/7E3yh8VpKLKvZC15GomB5HyxXHYbMm0S",
			ssoGEUrl : "https://geappliances.okta.com/app/geappliances_customernet_1/exksb2gzpsDzXBdyA697/sso/saml",
			logoutSSOUrl : "https://sso.geappliances.com/v2/logout?client_id=7E3yh8VpKLKvZC15GomB5HyxXHYbMm0S&returnTo=https://geappliancescustomernet.com",
            typeOfEmployeeAccessLevel: [
                {
                    typeOfEmployee: 'asm',
                    accessLevel: [
                        'Price',			// Done
                        'Price Discounts', 	// Done
                        'View Orders',
                        'Create New Order',	// Done
                        'Edit Orders',		// Done
            			'Returns/Credits',	// Done
            			'Invoices and Payments',
            			'Manage Users',		// Done
            			'User Requests',	// Done
            			'Approve Returns',	// Done
                        'View Reports',     // Done
                    ]
                }, 
				{
                    typeOfEmployee: 'om',
                    accessLevel: [
                        'Price',			// Done
                        'Price Discounts', 	// Done
                        'View Orders',
                        'Create New Order',	// Done
                        'Edit Orders',		// Done
            			'Returns/Credits',	// Done
            			'Invoices and Payments',
                        'View Reports',     // Done
                    ]
                },
				{
                    typeOfEmployee: 'dl',
                    accessLevel: [
                        'Price',			// Done
                        'Price Discounts', 	// Done
                        'View Orders',
                        'Create New Order',	// Done
                        'Edit Orders',		// Done
            			'Returns/Credits',	// Done
            			'Invoices and Payments',
            			'Manage Users',		// Done
            			'User Requests',	// Done
            			'Site Management',	// Done
            			'Approve Returns',	// Done
            			'Update User',
                        'View Reports',     // Done
                    ]
                }, {
                    typeOfEmployee: 'otherasm',
                    accessLevel: [
                        'Price',
                        'Price Discounts',
                        'View Orders',
                        'Create New Order',
                        'Edit Orders',
            			'Returns/Credits',	// Done
            			'Invoices and Payments',
                        'View Reports',     // Done
                    ]
                }, {
                    typeOfEmployee: 'normal',
                    accessLevel: [
                        'View Orders',
                    ]
                }
            ]
	    };
	} else if(location.indexOf('customer-dev.al.ge.com') !== -1 ) {
	    env = {
			orderAPIUrl: 'https://cnet.api.geappliances.io/orders-dev/',
			nodeAPIurl: 'https://cnet.api.geappliances.io/node-dev/',
			reportsAPIUrl: 'https://cnet.api.geappliances.io/reports-dev/',
			productAPIUrl: 'https://cnet.api.geappliances.io/products-dev/',
			s3BucketAPIBaseURL: 'https://cnet.api.geappliances.io/node-dev/requestUploadURL',
        		s3StaticDataURL: 'https://s3.amazonaws.com/ee-app-fileuploads-dev/CustomerNet',
            userAPIUrl: 'https://cnet.api.geappliances.io/users-dev/',
            servicesAPIUrl: 'https://cnet.api.geappliances.io/services-dev/',
			customerAPIUrl: 'https://cnet.api.geappliances.io/customers-dev/',
			cyberSourceRedirectURL: 'https://cnet.api.geappliances.io/node-dev/response',
			searchAndPayInvoicesURLEmp: 'https://globalerp-dev8.appl.ge.com:443',
            searchAndPayInvoicesURLCust: 'https://globalerp-dev8.appl.ge.com:443',
			loginAPIUrl: "https://cnet.api.geappliances.io/python-prd/",
			loginAPIKey: "rCG8agwU113D6hyzBlAAHactc88eCSr87GcDwNlk",
			westLoginAPIKey: "rCG8agwU113D6hyzBlAAHactc88eCSr87GcDwNlk",
			bootAPIUrl: "https://cnet-boot-api-dev.appl.ge.com/api/cnet/",
			pNetAPIUrl: "https://cnet-boot-api-dev.appl.ge.com/api/pnet/",
			cyberSourceURL: 'https://testsecureacceptance.cybersource.com/token/create',
			s3BrochureUrl: 'https://s3.amazonaws.com/ee-app-fileuploads-dev/CustomerNet/tmp/',
			profileId: "EC265CDE-05C0-42CB-9A14-8E9607E01A00",
			accessKey: "d73733766bf439c083dc27448b67ce97",
			hvac : {"name":"HVAC", "subCategory" : [ {"name":"Ducted HVAC", "categoryId":"3672"}, {"name":"Ductless HVAC", "categoryId":"3673"}]},
			ncrpData: {
				accountNumber: '116153688',
				legacyOrderAccountNumber: '89874214',
				invoiceToAddress: {
					ADDRESS1: "400 Buechel Bank Rd",
					CITY: "Louisville",
					POSTALCODE: "40225-0000",
					STATE: "KY",
					COUNTRY: "US",
				}
			},
			ssoUrl : "https://ssononprod.geappliances.com/samlp/PO211eFqansHfIkkuXJFae477dupTWt6",
			ssoGEUrl : "https://geappliances.okta.com/app/geappliances_customernet_1/exksb2gzpsDzXBdyA697/sso/saml",
			logoutSSOUrl : "https://ssononprod.geappliances.com/v2/logout?client_id=PO211eFqansHfIkkuXJFae477dupTWt6&returnTo=https://customernet-qa.geappliances.com",
            typeOfEmployeeAccessLevel: [
                {
                    typeOfEmployee: 'asm',
                    accessLevel: [
                        'Price',			// Done
                        'Price Discounts', 	// Done
                        'View Orders',
                        'Create New Order',	// Done
                        'Edit Orders',		// Done
            			'Returns/Credits',	// Done
            			'Invoices and Payments',
            			'Manage Users',		// Done
            			'User Requests',	// Done
            			'Approve Returns',	// Done
                        'View Reports',     // Done
                    ]
                }, 
				{
                    typeOfEmployee: 'om',
                    accessLevel: [
                        'Price',			// Done
                        'Price Discounts', 	// Done
                        'View Orders',
                        'Create New Order',	// Done
                        'Edit Orders',		// Done
            			'Returns/Credits',	// Done
            			'Invoices and Payments',
                        'View Reports',     // Done
                    ]
                },
				{
                    typeOfEmployee: 'dl',
                    accessLevel: [
                        'Price',			// Done
                        'Price Discounts', 	// Done
                        'View Orders',
                        'Create New Order',	// Done
                        'Edit Orders',		// Done
            			'Returns/Credits',	// Done
            			'Invoices and Payments',
            			'Manage Users',		// Done
            			'User Requests',	// Done
            			'Site Management',	// Done
            			'Approve Returns',	// Done
            			'Update User',
                        'View Reports',     // Done
                    ]
                }, {
                    typeOfEmployee: 'otherasm',
                    accessLevel: [
                        'Price',
                        'Price Discounts',
                        'View Orders',
                        'Create New Order',
                        'Edit Orders',
            			'Returns/Credits',	// Done
            			'Invoices and Payments',
                        'View Reports',     // Done
                    ]
                }, {
                    typeOfEmployee: 'normal',
                    accessLevel: [
                        'View Orders',
                    ]
                }
            ]
	    };
	} else if(location.indexOf('customernet-qa.geappliances.com') !== -1 ) {
	    env = {
			orderAPIUrl: 'https://cnet.api.geappliances.io/orders-qa/',
			nodeAPIurl: 'https://cnet.api.geappliances.io/node-qa/',
			reportsAPIUrl: 'https://cnet.api.geappliances.io/reports-qa/',
			productAPIUrl: 'https://cnet.api.geappliances.io/products-qa/',
			s3BucketAPIBaseURL: 'https://cnet.api.geappliances.io/node-qa/requestUploadURL',
			s3StaticDataURL: 'https://s3.amazonaws.com/ee-app-fileuploads-qa/CustomerNet',
            userAPIUrl: 'https://cnet.api.geappliances.io/users-qa/',
            servicesAPIUrl: 'https://cnet.api.geappliances.io/services-qa/',
			customerAPIUrl: 'https://cnet.api.geappliances.io/customers-qa/',
			cyberSourceRedirectURL: 'https://cnet.api.geappliances.io/node-qa/response',
			searchAndPayInvoicesURLEmp: 'https://globalerp-stg.appl.ge.com/',
			searchAndPayInvoicesURLCust: 'https://globalerp-stg.appl.ge.com/',
			loginAPIUrl: "https://cnet.api.geappliances.io/python-qa/",
			loginAPIKey: "K5oEPgaY5o1YcpoFdRuwPu5OAUBUCzK4fVytbe20",
			westLoginAPIKey: "K5oEPgaY5o1YcpoFdRuwPu5OAUBUCzK4fVytbe20",
			bootAPIUrl: "https://customernetapi-qa.geappliances.com/api/cnet/",
			pNetAPIUrl: "https://partsnetapi-qa.geappliances.com/api/pnet/",
			cyberSourceURL: 'https://testsecureacceptance.cybersource.com/token/create',
			s3BrochureUrl: 'https://s3.amazonaws.com/ee-app-fileuploads-qa/CustomerNet/tmp/',
			profileId: "EC265CDE-05C0-42CB-9A14-8E9607E01A00",
			accessKey: "d73733766bf439c083dc27448b67ce97",
			hvac : {"name":"HVAC", "subCategory" : [ {"name":"Ducted HVAC", "categoryId":"3672"}, {"name":"Ductless HVAC", "categoryId":"3673"}]},
			ncrpData: {
				accountNumber: '116153688',
				legacyOrderAccountNumber: '89874214',
				invoiceToAddress: {
					ADDRESS1: "400 Buechel Bank Rd",
            		CITY: "Louisville",
                	POSTALCODE: "40225-0000",
                	STATE: "KY",
                	COUNTRY: "US",
				}
			},
			ssoUrl : "https://ssononprod.geappliances.com/samlp/PO211eFqansHfIkkuXJFae477dupTWt6",
			ssoGEUrl : "https://geappliances.okta.com/app/geappliances_customernet_1/exksb2gzpsDzXBdyA697/sso/saml",
			logoutSSOUrl : "https://ssononprod.geappliances.com/v2/logout?client_id=PO211eFqansHfIkkuXJFae477dupTWt6&returnTo=https://customernet-qa.geappliances.com",
            typeOfEmployeeAccessLevel: [
                {
                    typeOfEmployee: 'asm',
                    accessLevel: [
                        'Price',			// Done
                        'Price Discounts', 	// Done
                        'View Orders',
                        'Create New Order',	// Done
                        'Edit Orders',		// Done
            			'Returns/Credits',	// Done
            			'Invoices and Payments',
            			'Manage Users',		// Done
            			'User Requests',	// Done
            			'Approve Returns',	// Done
                        'View Reports',     // Done
                    ]
                }, 
				{
                    typeOfEmployee: 'om',
                    accessLevel: [
                        'Price',			// Done
                        'Price Discounts', 	// Done
                        'View Orders',
                        'Create New Order',	// Done
                        'Edit Orders',		// Done
            			'Returns/Credits',	// Done
            			'Invoices and Payments',
                        'View Reports',     // Done
                    ]
                },
				{
                    typeOfEmployee: 'dl',
                    accessLevel: [
                        'Price',			// Done
                        'Price Discounts', 	// Done
                        'View Orders',
                        'Create New Order',	// Done
                        'Edit Orders',		// Done
            			'Returns/Credits',	// Done
            			'Invoices and Payments',
            			'Manage Users',		// Done
            			'User Requests',	// Done
            			'Site Management',	// Done
            			'Approve Returns',	// Done
            			'Update User',
                        'View Reports',     // Done
                    ]
                }, {
                    typeOfEmployee: 'otherasm',
                    accessLevel: [
                        'Price',
                        'Price Discounts',
                        'View Orders',
                        'Create New Order',
                        'Edit Orders',
            			'Returns/Credits',	// Done
            			'Invoices and Payments',
                        'View Reports',     // Done
                    ]
                }, {
                    typeOfEmployee: 'normal',
                    accessLevel: [
                        'View Orders',
                    ]
                }
            ]
	    };
	} else if(location.indexOf('customer-tst.al.ge.com') !== -1 ) {
	    env = {
			orderAPIUrl: 'https://cnet.api.geappliances.io/orders-tst/',
			nodeAPIurl: 'https://cnet.api.geappliances.io/node-tst/',
			reportsAPIUrl: 'https://cnet.api.geappliances.io/reports-tst/',
			productAPIUrl: 'https://cnet.api.geappliances.io/products-tst/',
			s3BucketAPIBaseURL: 'https://cnet.api.geappliances.io/node-tst/requestUploadURL',
			s3StaticDataURL: 'https://s3.amazonaws.com/ee-app-fileuploads-tst/CustomerNet',
            userAPIUrl: 'https://cnet.api.geappliances.io/users-tst/',
            servicesAPIUrl: 'https://cnet.api.geappliances.io/services-tst/',
			customerAPIUrl: 'https://cnet.api.geappliances.io/customers-tst/',
			cyberSourceRedirectURL: 'https://cnet.api.geappliances.io/node-tst/response',
			searchAndPayInvoicesURLEmp: 'https://globalerp-tst.appl.ge.com/',
            searchAndPayInvoicesURLCust: 'https://globalerp-tst.appl.ge.com/',
			loginAPIUrl: "https://cnet.api.geappliances.io/python-prd/",
			loginAPIKey: "rCG8agwU113D6hyzBlAAHactc88eCSr87GcDwNlk",
			westLoginAPIKey: "rCG8agwU113D6hyzBlAAHactc88eCSr87GcDwNlk",
			bootAPIUrl: "https://cnet-boot-api-tst.appl.ge.com/api/cnet/",
			pNetAPIUrl: "https://partsnetapi-qa.geappliances.com/api/pnet/",
			cyberSourceURL: 'https://testsecureacceptance.cybersource.com/token/create',
			s3BrochureUrl: 'https://s3.amazonaws.com/ee-app-fileuploads-tst/CustomerNet/tmp/',
			profileId: "EC265CDE-05C0-42CB-9A14-8E9607E01A00",
			accessKey: "d73733766bf439c083dc27448b67ce97",
			hvac : {"name":"HVAC", "subCategory" : [ {"name":"Ducted HVAC", "categoryId":"3672"}, {"name":"Ductless HVAC", "categoryId":"3673"}]},
			ssoUrl : "https://ssononprod.geappliances.com/samlp/PO211eFqansHfIkkuXJFae477dupTWt6",
			ssoGEUrl : "https://geappliances.okta.com/app/geappliances_customernet_1/exksb2gzpsDzXBdyA697/sso/saml",
			logoutSSOUrl : "https://ssononprod.geappliances.com/v2/logout?client_id=PO211eFqansHfIkkuXJFae477dupTWt6&returnTo=https://customernet-qa.geappliances.com",
            typeOfEmployeeAccessLevel: [
                {
                    typeOfEmployee: 'asm',
                    accessLevel: [
                        'Price',			// Done
                        'Price Discounts', 	// Done
                        'View Orders',
                        'Create New Order',	// Done
                        'Edit Orders',		// Done
            			'Returns/Credits',	// Done
            			'Invoices and Payments',
            			'Manage Users',		// Done
            			'User Requests',	// Done
            			'Approve Returns',	// Done
                        'View Reports',     // Done
                    ]
                }, 
				{
                    typeOfEmployee: 'om',
                    accessLevel: [
                        'Price',			// Done
                        'Price Discounts', 	// Done
                        'View Orders',
                        'Create New Order',	// Done
                        'Edit Orders',		// Done
            			'Returns/Credits',	// Done
            			'Invoices and Payments',
                        'View Reports',     // Done
                    ]
                },
				{
                    typeOfEmployee: 'dl',
                    accessLevel: [
                        'Price',			// Done
                        'Price Discounts', 	// Done
                        'View Orders',
                        'Create New Order',	// Done
                        'Edit Orders',		// Done
            			'Returns/Credits',	// Done
            			'Invoices and Payments',
            			'Manage Users',		// Done
            			'User Requests',	// Done
            			'Site Management',	// Done
            			'Approve Returns',	// Done
            			'Update User',
                        'View Reports',     // Done
                    ]
                }, {
                    typeOfEmployee: 'otherasm',
                    accessLevel: [
                        'Price',
                        'Price Discounts',
                        'View Orders',
                        'Create New Order',
                        'Edit Orders',
            			'Returns/Credits',	// Done
            			'Invoices and Payments',
                        'View Reports',     // Done
                    ]
                }, {
                    typeOfEmployee: 'normal',
                    accessLevel: [
                        'View Orders',
                    ]
                }
            ]
	    };
	}
	return env;
}

export const routes = {
    showDebuggerConsoles: false,
	orderAPIUrl: environment().orderAPIUrl,
	hvac : environment().hvac,
	ssoUrl : environment().ssoUrl,
	ssoGEUrl : environment().ssoGEUrl,
	logoutSSOUrl : environment().logoutSSOUrl,
	userDetailsKey : "R0VhcHBsaWVhbmNlIzEyMw==",
	productAPIUrl: environment().productAPIUrl,
	nodeAPIurl: environment().nodeAPIurl,
	reportsAPIUrl: environment().reportsAPIUrl,
    servicesAPIUrl: environment().servicesAPIUrl,
    userAPIUrl: environment().userAPIUrl,
    customerAPIUrl: environment().customerAPIUrl,
	searchAndPayInvoicesURLEmp: environment().searchAndPayInvoicesURLEmp,
    searchAndPayInvoicesURLCust: environment().searchAndPayInvoicesURLCust,
	profileId: environment().profileId,
	accessKey: environment().accessKey,
	cyberSourceRedirectURL: environment().cyberSourceRedirectURL,
	cyberSourceURL: environment().cyberSourceURL,
    typeOfEmployeeAccessLevel: environment().typeOfEmployeeAccessLevel,
	getItemsCount: 20,
	FED_EX : 'https://www.fedex.com/fedextrack/?trknbr=<TRACKING_NUMBER>',
	productGEUrl: "https://products.geappliances.com/MarketingObjectRetrieval/Dispatcher",
	geUrl: "https://www.geappliances.com",
    geUrlImageRootImages: "https://www.geappliances.com/content/migrated-root-images",
    geUrlImageMigratedAssets: "https://www.geappliances.com/content/migrated-assets",
	s3BucketAPIBaseURL: environment().s3BucketAPIBaseURL,
	s3StaticDataURL: environment().s3StaticDataURL,
	s3BrochureUrl: environment().s3BrochureUrl,
	adBuilderActionURL: "http://gecoop.staging.acbtest.com",
	pageSizeForGettingProductAvailability: 200,
	pageSizeForGettingProductPrices: 200,
	loginAPIUrl: environment().loginAPIUrl,
	loginAPIKey: { "x-api-key" : environment().loginAPIKey },
	westLoginAPIKey : { "x-api-key" : environment().westLoginAPIKey },
	bootAPIUrl: environment().bootAPIUrl,
	pNetAPIUrl: environment().pNetAPIUrl,
	localStorageVar: 'gessouserdetailscnet',
	redirectURLCNetVar: 'redirectURLCNet',
	pdfViewerLocalstorageVar: 'cnet-pdf-viewer-details',
	horizon:175,
	ncrpData: environment().ncrpData,
	users: {
		account: {
			path: 'account',
			method: 'GET'
		},
		login: {
			path: 'authentication',
			method: 'POST'
		},
		oauthLogin: {
			path: 'getAuthDetails',
			method: 'GET'
		},
		punchout: {
			path: 'oAuth/punchout',
			method: 'GET'
		},
		oauthDeleteLoginDetails: {
			path: 'deleteAuthDetails',
			method: 'DELETE'
		},
		notifications:{
			path: 'notifications',
			method: 'PUT'
		},
        accountResponsibility: {
            path: 'accountResponsibility',
			method: 'PUT'
        },
		details: {
			path: 'user',
			method: 'GET'
		},
		adminDetails: {
			path: 'user',
			method: 'GET'
		},
        asm: {
			path: 'account',
			method: 'GET'
		},
		access: {
			path: 'account',
			method: 'PUT'
		},
		update: {
			path: 'user',
			method: 'PUT'
		},
		delete: {
			path: 'user',
			method: 'DELETE'
		},
		deleteAccount: {
			path: 'account',
			method: 'DELETE'
		},
        createTokenAccount: {
			path: 'account/register',
			method: 'POST'
		},
		nonGEASSOUserAccounts: {
			path: 'nonGEASSOAccount',
			method: 'GET'
		},
		ncrpSalesAgreement: {
			path: 'salesAgreement',
			method: 'GET'
		}
	},
	list: {
		get: {
			path: 'wishlist',
			method: 'GET'
		},
		post: {
			path: 'wishlist',
			method: 'POST'
		},
		put: {
			path: 'wishlist',
			method: 'PUT'
		},
		delete: {
			path: 'wishlist',
			method: 'DELETE'
		}
	},
	cart: {
		get: {
			path: 'cart',
			method: 'GET'
		},
		post: {
			path: 'cart',
			method: 'POST'
		},
		put: {
			path: 'cart',
			method: 'PUT'
		},
		delete: {
			path: 'cart',
			method: 'DELETE'
		},
		getProductsFromS3: {
			path: 'item',
			method: 'GET'
		},
	},
	homepage: {
		assets: {
			path: 'homePageAssets',
			method: 'GET'
		},
		asset: {
			path: 'asset',
			method: 'GET'
		},
		createAsset: {
			path: 'asset',
			method: 'POST'
		},
		editAsset: {
			path: 'asset',
			method: 'POST'
		},
		deleteAsset: {
			path: 'asset',
			method: 'DELETE'
		},
		message: {
			path: 'message',
			method: 'GET'
		},
		createMessage: {
			path: 'message',
			method: 'POST'
		},
		editMessage: {
			path: 'message',
			method: 'POST'
		},
		deleteMessage: {
			path: 'message',
			method: 'DELETE'
		},
	},
	orders: {
        itemOrderability: {
            path: 'order/itemOrderability',
			method: 'GET'
        },
		cancelPackageOrder:{
			path: 'order',
			method: 'DELETE'
		},
        decliningBalance: {
            path: 'order/decliningBalance',
            method: 'POST'
        },
        personShipTo: {
            path: 'order/personShipTo',
            method: 'POST'
        },
        deleteReturn: {
            path: 'order',
			method: 'DELETE'
        },
        validateWarehouseCode: {
			path: 'order/location',
			method: 'GET'
		},
		billingReferences: {
			path: 'orders',
			method: 'GET'
		},
        getPOD: {
			path: 'order/pod',
			method: 'GET'
		},
		getShippingMethod: {
			path: 'shippingMethod',
			method: 'GET'
		},
		getDeliveryCalendar: {
			path: 'delivery-calendar',
			method: 'POST'
		},
		restockingFee: {
			path: 'order/restockingFee',
			method: 'POST'
		},
		getOrderList: {
			path: 'orders',
			method: 'GET'
		},
		getOrderListBoot: {
			path: 'order',
			method: 'GET'
		},
		approveReturn: {
			path: 'order',
			method: 'POST'
		},
		getServices: {
			path: 'order',
			method: 'POST'
		},
		getTax: {
			path: 'tax',
			method: 'POST'
		},
		exportOrders: {
			path: 'exportOrders',
			method: 'POST'
		},
		exportManageOrders: {
			path: 'manageOrder',
			method: 'POST'
		},
		exportViewOrders: {
			path: 'order',
			method: 'POST'
		},
		deleteOrder: {
			path: 'order',
			method: 'DELETE'
		},
		cancelOrder: {
			path: 'order',
			method: 'DELETE'
		},
		getShippingAddresses: {
			path: 'order/shipping',
			method: 'GET'
		},
		getFiles : {
			path: 'getFiles',
			method: 'GET'
		},
        invoice: {
			path: 'invoice',
			method: 'GET'
		},
		printViewRequestDetails: {
			path: 'order',
			method: 'POST'
		},
		printProofOfDelivery: {
			path: 'order',
			method: 'POST'
		},
		getSignature: {
			path: 'pod',
			method: 'GET'
		},
		signature: {
			path: 'signature',
			method: 'GET'
		},
		processPartsOrder: {
			path: 'order',
			method: 'POST'
		}
	},
	priceTags: {
		create: {
			path: 'priceTag',
			method: 'POST'
		}
	},
	brochure: {
		savedBrochures: {
			path: 'brochure',
			method: 'GET'
		},
		deleteBrochure: {
			path: 'brochure',
			method: 'DELETE'
		},
		createBrochure: {
			path: 'brochure',
			method: 'POST'
		},
        sendEmail: {
            path: 'email',
            method: 'POST'
        },
		brochureTemplateOption: {
			path: 'brochure',
			method: 'GET'
		}
	},
    packages: {
        quoteModels: {
			path: 'brochure',
			method: 'GET'
		},
    },
	product: {
		priceOrder: {
			path: 'pricing',
			method: 'POST'
		},
		export: {
			path: 'report',
			method: 'POST'
		},
		adc: {
			path: 'adc',
            method: 'GET'
		},
        getKeyWordSuggession: {
            path: 'item',
            method: 'GET'
        },
		getProductSpecs: {
			path: 'item',
            method: 'GET'
		},
		checkAvailability: {
			path: 'availability',
			method: 'POST'
		},
		checkPrices: {
			path: 'pricing',
			method: 'POST'
		},
		pinItemInfo: {
			path: 'pim',
			method: 'POST'
		},
		printSpecsPDF: {
			path: 'spec',
			method: 'GET'
		},
		getSearchResult: {
			path: 'item',
			method: 'GET'
		},
		getProductLineFilters: {
			path: 'filter',
			method: 'POST'
		},
		getNarrowProductLineFilters: {
			path: 'item',
			method: 'GET'
		},
		getQuoteModel: {
			path: 'item',
			method: 'GET'
		},
		getPOKItems: {
			path: 'pok',
			method: 'GET'
		}
    },
	exports: {
		getSavedExports: {
			path: 'priceTemplate',
            method: 'GET'
		},
		deletePriceTemplate: {
			path: 'priceTemplate',
            method: 'DELETE'
		},
		createPriceTemplate: {
			path: 'priceTemplate',
            method: 'POST'
		},
		updatePriceTemplate: {
			path: 'priceTemplate',
            method: 'PUT'
		},
		runExport: {
			path: 'report',
			method: 'POST'
		},
		getMonogramData: {
			path: 'reports',
			method: 'GET'
		},
		getPerformanceData: {
			path: 'reports',
			method: 'GET'
		},
		getPrestigeData: {
			path: 'reports',
			method: 'GET'
		},
		getGeDistributorData: {
			path: 'reports',
			method: 'GET'
		},
		productPurchaseReport: {
			path: 'salesReport/export',
			method: 'POST'
		}
	},
    prelogin: {
	    searchProductNumberKeyword: 'item',
	    getProductLineFilters: 'filter',
	    checkAvailability: 'availability',
	    geCustomerNetRegistration: {
            path: 'registration',
            method: 'POST'
        },
	    addressVerification: {
            path: 'address',
            method: 'GET'
        }
	},
	resources: {
		salesReport: {
			path: 'salesReport',
            method: 'GET'
		},
		mapGuideLines: {
			path: 'documents',
            method: 'GET'
		},
		registrationHelp: {
			path: 'registrationHelp',
            method: 'GET'
		},
		handbooks: {
			path: 'documents',
            method: 'GET'
		},
		freightDocument: {
			path: 'discount',
			method: 'GET'
		},
		partsCatalog: {
			path: 'catlog',
			method: 'GET'
		},
		partsPricingFile: {
			path: 'priceReports',
			method: 'GET'
		},
		multiPackFile: {
			path: 'multiPackFile',
			method: 'GET'
		},
		weightAndDimensionsFile: {
			path: 'weightAndDimensionsFile',
			method: 'GET'
		},
		siteManagement: {
			path: 'siteManagement',
			method: 'POST'
		}
	},
	tca: {
		invoiceAge: {
			path: 'tca/invoiceAge',
            method: 'GET'
		},
		getAllTca: {
			path: 'tca/getAllTca',
            method: 'GET'
		},
		storeReturnUda: {
			path: 'tca/storeReturnUda',
            method: 'POST'
		},
		storeCreditUda: {
			path: 'tca/storeCreditUda',
            method: 'POST'
		}
	},
	ajdprcmod: {
		getAllAdjPrcMod: {
			path: 'ajdprcmod/list',
			method: 'GET'
		}
	}
}



// WEBPACK FOOTER //
// ./src/App/redux/api/routes.js